import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { ShieldCheck, ArrowLeft } from "lucide-react";

export default function LegalPage({ title, description, canonical, children }) {
  return (
    <div className="min-h-screen bg-white text-slate-800" data-testid="legal-page">
      {(title || description || canonical) && (
        <Helmet>
          {title && <title>{title}</title>}
          {description && <meta name="description" content={description} />}
          {canonical && <link rel="canonical" href={canonical} />}
        </Helmet>
      )}
      <header className="sticky top-0 z-20 border-b border-slate-200 bg-white/90 backdrop-blur"
        data-testid="legal-header">
        <div className="mx-auto flex max-w-4xl items-center justify-between px-4 py-4">
          <Link to="/" className="flex items-center gap-2 font-bold text-slate-900 no-underline"
            data-testid="legal-brand-home">
            <span className="grid h-8 w-8 place-items-center rounded-lg bg-[#2A9D8F] text-white">
              <ShieldCheck size={18} />
            </span>
            AuditPDF
          </Link>
          <Link to="/"
            className="inline-flex items-center gap-2 rounded-full border border-slate-200 px-4 py-2 text-sm font-semibold text-slate-600 no-underline transition-colors hover:border-slate-300 hover:text-slate-900"
            data-testid="back-to-home-btn">
            <ArrowLeft size={16} /> Back to Home
          </Link>
        </div>
      </header>
      <main>{children}</main>
    </div>
  );
}
